import { useSyncExternalStore } from 'react';
import { onlineManager } from '@tanstack/react-query';
import { useT } from '../i18n';

/**
 * Said once, at the top, while the browser is offline. Nothing is lost meanwhile: reads wait
 * and refetch when the connection is back, writes are held and sent then (TanStack Query's
 * network mode), and a screen that can't load says so (ErrorScreen).
 */
export function OfflineNote() {
  const t = useT();
  const online = useSyncExternalStore(
    (cb) => onlineManager.subscribe(cb),
    () => onlineManager.isOnline(),
    () => true,
  );
  if (online) return null;
  return (
    <p className="offline" role="status" data-testid="offline">
      {t('common.offline')}
    </p>
  );
}
